export default "__VITE_ASSET__RpO5od8M__"